import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './privacy-policy.css'

const PrivacyPolicy = (props) => {
  return (
    <div className="privacy-policy-container">
      <span className="privacy-policy-title">
        {props.datenschutzerklaerungTitle ?? (
          <Fragment>
            <span className="privacy-policy-text100">Datenschutzerklärung</span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-intro-text">
        {props.datenschutzerklaerungText ?? (
          <Fragment>
            <span className="privacy-policy-text101">
              <span>
                Der Schutz Ihrer persönlichen Daten ist uns ein besonderes
                Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf
                Grundlage der gesetzlichen Bestimmungen (insbesondere DSGVO, TKG
                2021) sowie nach den Prinzipien von Datensouveränität, Privacy
                by Design und minimaler Abhängigkeit von Drittanbietern.
              </span>
              <br></br>
              <br></br>
              <span>
                Im Folgenden informieren wir Sie über die Art, den Umfang und
                den Zweck der Datenverarbeitung auf dieser Website.
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-verantwortlicher-title">
        {props.verantwortlicherTitle ?? (
          <Fragment>
            <span className="privacy-policy-text114">
              Verantwortlicher für die Datenverarbeitung
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-verantwortlicher-text">
        {props.verantwortlicherText ?? (
          <Fragment>
            <span className="privacy-policy-text106">
              <span>Stefan Lacher</span>
              <br></br>
              <span>Siehdichfürstraße 131</span>
              <br></br>
              <span>2231 Strasshof an der Nordbahn, Österreich</span>
              <br></br>
              <span>E-Mail: contact@stefanlacher.com</span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-technische-infrastructure-title">
        {props.technischeInfrastrukturTitle ?? (
          <Fragment>
            <span className="privacy-policy-text162">
              Technische Infrastruktur &amp; Auftragsverarbeiter
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-technische-infrastructure-text">
        {props.technischeInfrastrukturText ?? (
          <Fragment>
            <span className="privacy-policy-text163">
              Unsere Infrastruktur setzt sich aus folgenden Bereichen zusammen:
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-cloud-hosting-subtitle">
        {props.cloudHostingTitle ?? (
          <Fragment>
            <span className="privacy-policy-text164">
              Cloud-Hosting (öffentliche Infrastruktur):
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-cloud-hosting-subtext">
        {props.cloudHostingText ?? (
          <Fragment>
            <span className="privacy-policy-text149">
              <span>
                Die Website selbst (Frontend auf Basis von React, Backend API
                mit FastAPI) sowie datenschutzfreundliche Analyse-Dienste (Umami
                oder Matomo, self-hosted) werden in einer Cloud-Umgebung
                betrieben.
              </span>
              <br></br>
              <span>
                Die Cloud-Infrastruktur wird durch **Cloudflare** (DDoS-Schutz,
                Bot-Protection, DNS, SSL/TLS) sowie eigene Reverse-Proxies
                (z. B. Caddy oder Traefik) abgesichert.
              </span>
              <br></br>
              <span>
                Die Cloud-Umgebung unterliegt unserer administrativen Kontrolle,
                erfolgt technisch jedoch über externe Hosting-Dienstleister.
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-on-premise-infra-subtitle">
        {props.onPremisesTitle ?? (
          <Fragment>
            <span className="privacy-policy-text155">
              On-Premises Infrastruktur (eigene Server):
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-on-premise-infra-subtext">
        {props.onPremisesText ?? (
          <Fragment>
            <span className="privacy-policy-text156">
              <span>
                Sämtliche Monitoring-, Logging- und Überwachungsdaten verbleiben
                ausschließlich auf eigener, selbst betriebener Infrastruktur
                (Self-Hosting, On-Premises).
              </span>
              <br></br>
              <span>
                Eingesetzte Systeme: Grafana, Prometheus, OpenSearch, Telegraf,
                Sentry, InfluxDB (optional).
              </span>
              <br></br>
              <span>
                Die Übertragung von Logs, Metriken und Fehlerberichten aus der
                Cloud erfolgt ausschließlich über verschlüsselte VPN/SSH-Tunnel
                direkt in unsere eigene Infrastruktur.
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-auftragsverarbeiter-subtitle">
        {props.auftragsverarbeiterTitle ?? (
          <Fragment>
            <span className="privacy-policy-text141">
              Eingesetzte Auftragsverarbeiter:
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-auftragsverarbeiter-subtext">
        {props.auftragsverarbeiterText1 ?? (
          <Fragment>
            <span className="privacy-policy-text142">
              <span>Namecheap: Domainregistrierung und DNS-Verwaltung</span>
              <br></br>
              {/* <span>
                Cloudflare: Sicherheitsinfrastruktur, DDoS-Schutz,
                DNS-Optimierung
              </span>
              <br></br> */}
              <span>
                Externe Hosting-Dienstleister für Cloudbetrieb:
                Anwendungsbetrieb der Website
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-datenweitergabe">
        {props.auftragsverarbeiterText2 ?? (
          <Fragment>
            <span className="privacy-policy-text148">
              Eine darüberhinausgehende Datenweitergabe an Dritte erfolgt nicht.
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-daten-webseite-subtitle">
        {props.erhobeneDatenTitle ?? (
          <Fragment>
            <span className="privacy-policy-text115">
              Erhobene Daten beim Website-Besuch
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-daten-webseite-subtext">
        {props.erhobeneDatenText ?? (
          <Fragment>
            <span className="privacy-policy-text116">
              <span>
                Beim Aufruf dieser Website werden folgende Daten automatisiert
                verarbeitet:
              </span>
              <br></br>
              <br></br>
              <span>- IP-Adresse des aufrufenden Endgeräts</span>
              <br></br>
              <span>- Datum und Uhrzeit des Zugriffs</span>
              <br></br>
              <span>- Aufgerufene Seiten/Dateien</span>
              <br></br>
              <span>- Browsertyp und Betriebssystem</span>
              <br></br>
              <br></br>
              <span>Diese Daten werden verwendet für:</span>
              <br></br>
              <br></br>
              <span>- Betrieb und Absicherung der Website</span>
              <br></br>
              <span>
                - Fehlerüberwachung und Performance-Optimierung (mittels Sentry,
                selbst betrieben)
              </span>
              <br></br>
              <span>
                - Datenschutzkonforme Analyse der Seitenzugriffe (mittels Umami
                oder Matomo, selbst betrieben)
              </span>
              <br></br>
              <br></br>
              <span>
                Es findet keine Weitergabe an Dritte zu Marketingzwecken statt.
              </span>
              <br></br>
              <br></br>
              <span>Cookie zur Speicherung Ihrer Auswahl:</span>
              <br></br>
              <span>
                Zur Speicherung Ihrer Entscheidung im Cookie-Consent-Banner wird ein technisch notwendiges Cookie gesetzt. Dieses speichert lediglich, ob und welche Cookie-Kategorien Sie akzeptiert haben. Das Cookie enthält keine personenbezogenen Daten und bleibt für maximal 12 Monate gespeichert.
              </span>

              
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-speicherdauer-subtitle">
        {props.speicherdauerTitle ?? (
          <Fragment>
            <span className="privacy-policy-text140">Speicherdauer</span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-speicherdauer-subtext">
        {props.speicherdauerText ?? (
          <Fragment>
            <span className="privacy-policy-text201">
              <span>
                Technische Log-Daten werden maximal 30 Tage gespeichert und
                danach gelöscht.
              </span>
              <br></br>
              <span>
                Anonymisierte Analyse-Daten aus Umami oder Matomo werden maximal
                12 Monate aufbewahrt.
              </span>
              <br></br>
              <span>
                Monitoring- und Fehlerdaten in der On-Premises Infrastruktur
                werden ausschließlich intern und nach Zweckbindung gespeichert.
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-social-verlinkung-subtitle">
        {props.socialMediaTitle ?? (
          <Fragment>
            <span className="privacy-policy-text207">
              Social-Media-Verlinkungen
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-social-verlinkung-subtext">
        {props.socialMediaText ?? (
          <Fragment>
            <span className="privacy-policy-text208">
              <span>Unsere Website enthält Links zu externen Plattformen:</span>
              <br></br>
              <br></br>
              <span>- LinkedIn</span>
              <br></br>
              <span>- Medium</span>
              <br></br>
              <span>- GitHub</span>
              <br></br>
              <br></br>
              <span>
                Beim bloßen Besuch unserer Website werden keine Daten an diese
                Anbieter übertragen. Erst durch aktives Anklicken eines Links
                verlassen Sie unsere Website und unterliegen den jeweiligen
                Datenschutzrichtlinien der externen Plattform.
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-drittland-subtitle">
        {props.drittlanduebermittlungTitle ?? (
          <Fragment>
            <span className="privacy-policy-text220">
              Keine Drittlandübermittlung
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-drittland-subtext">
        {props.drittlanduebermittlungText ?? (
          <Fragment>
            <span className="privacy-policy-text180">
              Die Datenverarbeitung erfolgt ausschließlich innerhalb der EU bzw.
              unter unserer direkten Kontrolle. Eine Übermittlung in
              Drittstaaten findet nicht statt.
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-rechte-subtitle">
        {props.rechteTitle ?? (
          <Fragment>
            <span className="privacy-policy-text181">
              Ihre Rechte gemäß Datenschutz-Grundverordnung
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-rechte-subtext">
        {props.rechteText ?? (
          <Fragment>
            <span className="privacy-policy-text182">
              <span>Sie haben das Recht auf:</span>
              <br></br>
              <br></br>
              <span>
                - Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)
              </span>
              <br></br>
              <span>- Berichtigung unrichtiger Daten (Art. 16 DSGVO)</span>
              <br></br>
              <span>- Löschung Ihrer Daten (Art. 17 DSGVO)</span>
              <br></br>
              <span>- Einschränkung der Verarbeitung (Art. 18 DSGVO)</span>
              <br></br>
              <span>- Datenübertragbarkeit (Art. 20 DSGVO)</span>
              <br></br>
              <span>- Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</span>
              <br></br>
              <br></br>
              <span>
                Zur Ausübung Ihrer Rechte kontaktieren Sie bitte:
                contact@stefanlacher.com
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-aufsicht-subtitle">
        {props.aufsichtsbehoerdeTitle ?? (
          <Fragment>
            <span className="privacy-policy-text200">Aufsichtsbehörde</span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-aufsicht-subtext">
        {props.aufsichtsbehoerdeText ?? (
          <Fragment>
            <span className="privacy-policy-text165">
              <span>
                Sollten Sie der Ansicht sein, dass Ihre Daten unrechtmäßig
                verarbeitet werden, können Sie sich bei der Datenschutzbehörde
                beschweren:
              </span>
              <br></br>
              <br></br>
              <span>Österreichische Datenschutzbehörde</span>
              <br></br>
              <span>Barichgasse 40–42, 1030 Wien</span>
              <br></br>
              <span>www.dsb.gv.at</span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-schlussbemerkung-subtitle">
        {props.schlussbemerkungTitle ?? (
          <Fragment>
            <span className="privacy-policy-text174">Schlussbemerkung</span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-schlussbemerkung-subtext">
        {props.schlussbemerkungText1 ?? (
          <Fragment>
            <span className="privacy-policy-text175">
              <span>
                Wir setzen alles daran, Ihre Daten unter eigener Kontrolle zu
                halten und die Privatsphäre bestmöglich zu schützen.
              </span>
              <br></br>
              <span>
                Der bewusste Verzicht auf datenhungrige Dienste wie Google
                Analytics und der Einsatz datensouveräner Open-Source-Lösungen
                unterstreichen unser Engagement für Ihre Privatsphäre.
              </span>
            </span>
          </Fragment>
        )}
      </span>
      <span className="privacy-policy-hinweis">
        {props.schlussbemerkungText2 ?? (
          <Fragment>
            <span className="privacy-policy-text179">
              Hinweis: Diese Datenschutzerklärung wird laufend an technische
              Entwicklungen und gesetzliche Vorgaben angepasst. Sie wurde unter
              Berücksichtigung der Empfehlungen und Muster der Wirtschaftskammer
              Österreich (WKO) sowie der WKO-Checkliste zur Datenschutzerklärung
              erstellt.
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

export default PrivacyPolicy
